"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRailsTimezone = getRailsTimezone;
const IANA_TO_RAILS = {
    // US
    'America/New_York': 'Eastern Time (US & Canada)',
    'America/Chicago': 'Central Time (US & Canada)',
    'America/Denver': 'Mountain Time (US & Canada)',
    'America/Phoenix': 'Arizona',
    'America/Los_Angeles': 'Pacific Time (US & Canada)',
    'America/Anchorage': 'Alaska',
    'America/Juneau': 'Alaska',
    'Pacific/Honolulu': 'Hawaii',
    // Canada (mapped to closest Rails equivalent)
    'America/St_Johns': 'Newfoundland',
    'America/Halifax': 'Atlantic Time (Canada)',
    'America/Toronto': 'Eastern Time (US & Canada)',
    'America/Winnipeg': 'Central Time (US & Canada)',
    'America/Regina': 'Saskatchewan',
    'America/Edmonton': 'Mountain Time (US & Canada)',
    'America/Vancouver': 'Pacific Time (US & Canada)',
    'America/Whitehorse': 'Pacific Time (US & Canada)',
    // Americas (Other)
    'Pacific/Pago_Pago': 'American Samoa',
    'Pacific/Midway': 'Midway Island',
    'Pacific/Apia': 'Samoa',
    'America/Tijuana': 'Tijuana',
    'America/Chihuahua': 'Chihuahua',
    'America/Mazatlan': 'Mazatlan',
    'America/Guatemala': 'Central America',
    'America/Mexico_City': 'Mexico City',
    'America/Monterrey': 'Monterrey',
    'America/Indiana/Indianapolis': 'Indiana (East)',
    'America/Bogota': 'Bogota',
    'America/Lima': 'Lima',
    'America/Caracas': 'Caracas',
    'America/La_Paz': 'La Paz',
    'America/Santiago': 'Santiago',
    'America/Sao_Paulo': 'Brasilia',
    'America/Argentina/Buenos_Aires': 'Buenos Aires',
    'America/Guyana': 'Georgetown',
    'America/Godthab': 'Greenland',
    'America/Nuuk': 'Greenland',
    // Atlantic
    'Atlantic/South_Georgia': 'Mid-Atlantic',
    'Atlantic/Azores': 'Azores',
    'Atlantic/Cape_Verde': 'Cape Verde Is.',
    // Europe
    'Europe/Dublin': 'Dublin',
    'Europe/Lisbon': 'Lisbon',
    'Europe/London': 'London',
    'Europe/Amsterdam': 'Amsterdam',
    'Europe/Belgrade': 'Belgrade',
    'Europe/Berlin': 'Berlin',
    'Europe/Zurich': 'Bern',
    'Europe/Bratislava': 'Bratislava',
    'Europe/Brussels': 'Brussels',
    'Europe/Budapest': 'Budapest',
    'Europe/Copenhagen': 'Copenhagen',
    'Europe/Ljubljana': 'Ljubljana',
    'Europe/Madrid': 'Madrid',
    'Europe/Paris': 'Paris',
    'Europe/Prague': 'Prague',
    'Europe/Rome': 'Rome',
    'Europe/Sarajevo': 'Sarajevo',
    'Europe/Skopje': 'Skopje',
    'Europe/Stockholm': 'Stockholm',
    'Europe/Vienna': 'Vienna',
    'Europe/Warsaw': 'Warsaw',
    'Europe/Zagreb': 'Zagreb',
    'Europe/Bucharest': 'Bucharest',
    'Europe/Helsinki': 'Helsinki',
    'Europe/Kyiv': 'Kyiv',
    'Europe/Riga': 'Riga',
    'Europe/Sofia': 'Sofia',
    'Europe/Tallinn': 'Tallinn',
    'Europe/Vilnius': 'Vilnius',
    'Europe/Athens': 'Athens',
    'Europe/Istanbul': 'Istanbul',
    'Europe/Minsk': 'Minsk',
    'Europe/Moscow': 'Moscow',
    'Europe/Volgograd': 'Volgograd',
    // Africa
    'Africa/Casablanca': 'Casablanca',
    'Africa/Monrovia': 'Monrovia',
    'Africa/Algiers': 'West Central Africa',
    'Africa/Cairo': 'Cairo',
    'Africa/Harare': 'Harare',
    'Africa/Johannesburg': 'Pretoria',
    'Africa/Nairobi': 'Nairobi',
    // Middle East / Central Asia
    'Asia/Jerusalem': 'Jerusalem',
    'Asia/Amman': 'Amman',
    'Asia/Kuwait': 'Kuwait',
    'Asia/Riyadh': 'Riyadh',
    'Asia/Baghdad': 'Baghdad',
    'Asia/Tehran': 'Tehran',
    'Asia/Muscat': 'Muscat',
    'Asia/Baku': 'Baku',
    'Asia/Tbilisi': 'Tbilisi',
    'Asia/Yerevan': 'Yerevan',
    'Asia/Kabul': 'Kabul',
    'Asia/Yekaterinburg': 'Ekaterinburg',
    'Asia/Karachi': 'Karachi',
    'Asia/Tashkent': 'Tashkent',
    // South Asia
    'Asia/Kolkata': 'Kolkata',
    'Asia/Colombo': 'Sri Jayawardenepura',
    'Asia/Kathmandu': 'Kathmandu',
    // East/Southeast Asia
    'Asia/Almaty': 'Almaty',
    'Asia/Dhaka': 'Dhaka',
    'Asia/Novosibirsk': 'Novosibirsk',
    'Asia/Rangoon': 'Rangoon',
    'Asia/Yangon': 'Rangoon',
    'Asia/Bangkok': 'Bangkok',
    'Asia/Jakarta': 'Jakarta',
    'Asia/Krasnoyarsk': 'Krasnoyarsk',
    'Asia/Shanghai': 'Beijing',
    'Asia/Chongqing': 'Chongqing',
    'Asia/Hong_Kong': 'Hong Kong',
    'Asia/Irkutsk': 'Irkutsk',
    'Asia/Kuala_Lumpur': 'Kuala Lumpur',
    'Asia/Singapore': 'Singapore',
    'Asia/Taipei': 'Taipei',
    'Asia/Ulaanbaatar': 'Ulaan Bataar',
    'Asia/Urumqi': 'Urumqi',
    'Asia/Tokyo': 'Tokyo',
    'Asia/Seoul': 'Seoul',
    'Asia/Yakutsk': 'Yakutsk',
    // Oceania
    'Australia/Perth': 'Perth',
    'Australia/Adelaide': 'Adelaide',
    'Australia/Darwin': 'Darwin',
    'Australia/Brisbane': 'Brisbane',
    'Australia/Melbourne': 'Melbourne',
    'Australia/Hobart': 'Hobart',
    'Australia/Sydney': 'Sydney',
    'Pacific/Guam': 'Guam',
    'Pacific/Port_Moresby': 'Port Moresby',
    'Asia/Vladivostok': 'Vladivostok',
    'Asia/Magadan': 'Magadan',
    'Pacific/Noumea': 'New Caledonia',
    'Pacific/Guadalcanal': 'Solomon Is.',
    'Pacific/Auckland': 'Auckland',
    'Pacific/Fiji': 'Fiji',
    'Asia/Kamchatka': 'Kamchatka',
    'Pacific/Majuro': 'Marshall Is.',
    'Pacific/Tongatapu': "Nuku'alofa",
    // UTC
    'Etc/UTC': 'UTC',
};
function getRailsTimezone(ianaName) {
    return IANA_TO_RAILS[ianaName] || ianaName;
}
